$(function() {
    $('.show-pass-btn').on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();

        const dataAriaLabelShow = event.target.dataset.ariaLabelShow;
        const dataAriaLabelHide = event.target.dataset.ariaLabelHide;

        const thisInput = $(this).siblings('.form-control');
        const thisInputIcon = $(this).find('.fa');

        if(thisInput.attr('type') === 'password') {
            thisInput.attr('type', 'text');
            thisInputIcon.addClass('fa-eye-slash');
            thisInputIcon.removeClass('fa-eye');
            event.target.setAttribute('aria-label', dataAriaLabelHide);
        } else {
            thisInput.attr('type', 'password');
            thisInputIcon.addClass('fa-eye');
            thisInputIcon.removeClass('fa-eye-slash');
            event.target.setAttribute('aria-label', dataAriaLabelShow);
        }
    });
});
